import { suggestionBadge } from '@/views/content/suggestionBadge'

export default [
  {
    header: 'Контент',
    resource: 'content',
    action: 'view',
  },
  {
    title: 'Предложка',
    route: 'content-suggestions',
    icon: 'InboxIcon',
    tagVariant: 'light-warning',
    resource: 'content',
    action: 'view',
    // Число pending-предложек; рендер меню трекает observable — бэдж обновляется реактивно.
    get tag() {
      return suggestionBadge.count
    },
  },
]
